import React from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

const errorMessages: { [key: string]: string } = {
  'auth/wrong-credentials': 'Identifiant (numéro de CP) ou mot de passe incorrect',
  'auth/email-already-in-use': "L'adresse email existe déjà",
  'auth/user-not-found': "L'adresse email n'existe pas",
  'auth/invalid-action-code': 'Le code a expiré ou incorrect',
  'auth/cannot-reset-password': 'Réinitialisation du mot de passe impossible',
  'auth/invalid-username': "Nom d'utilisateur incorrect",
  'report/submit-error': 'Création ou Enregistrement du rapport impossible',
  'emargement/submit-error': 'Création ou Validation impossible',
};

const useStyles = makeStyles((theme) => ({
  error: {
    backgroundColor: theme.palette.error.main,
    color: '#fff',
    padding: theme.spacing(2),
    marginTop: theme.spacing(3),
  },
}));

type ErrorProps = {
  className?: string;
  errorCode: string;
};

export const Error: React.FC<ErrorProps> = ({ className, errorCode }: ErrorProps) => {
  const classes = useStyles();
  return (
    <Paper className={classnames(classes.error, className)} elevation={0}>
      {errorMessages[errorCode] || 'Erreur inconnue'}
    </Paper>
  );
};

export default Error;
